import { render, staticRenderFns } from "./arquivo-gerado.vue?vue&type=template&id=6d025a54&scoped=true&"
import script from "./arquivo-gerado.vue?vue&type=script&lang=js&"
export * from "./arquivo-gerado.vue?vue&type=script&lang=js&"
import style0 from "./arquivo-gerado.vue?vue&type=style&index=0&id=6d025a54&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d025a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d025a54')) {
      api.createRecord('6d025a54', component.options)
    } else {
      api.reload('6d025a54', component.options)
    }
    module.hot.accept("./arquivo-gerado.vue?vue&type=template&id=6d025a54&scoped=true&", function () {
      api.rerender('6d025a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/arquivo-gerado/arquivo-gerado.vue"
export default component.exports